import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';
import { RoundPrimitiveButton } from './RoundPrimitiveButton';

export const FloatingButton = styled(RoundPrimitiveButton)`
  height: 50px !important;
  background-color: ${RoutalPalette.white};
  color: black;
  width: 50px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  border-radius: 50%;
`;
export const FloatingButtonShadow = styled(Grid)`
  height: 50px !important;
  background-color: ${RoutalPalette.white};
  color: black;
  width: 50px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  border-radius: 50%;
`;
